import React from 'react'
import Announcement from 'app/gears/announcements/components/Announcement'

/**
 * A real-time rendering of the announcement markdown as the user types
 * 
 * @author Alex Clary
 * 
 * @param formvalues the values of the form
 * 
 */
const AnnouncementPreviewSection = ({ formValues }) =>
  <section>
    <h3>Preview</h3>
    <hr />
    <Announcement announcement={{ beginDate: new Date().getTime(), endDate: new Date().getTime(), creationDate: new Date().getTime(), ...formValues }} />
    <hr />
  </section>

export default AnnouncementPreviewSection